import React from 'react';
import Container from 'react-bootstrap/Container';
import UnstyledRow from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Project from '../components/project';
import Link from '../components/link';
import Image from 'react-bootstrap/Image';
import styled from 'styled-components';

const Row = styled(UnstyledRow)`
  justify-content: center;
`;

const Paragraph = styled.p`
  margin: 1.5rem 0px;
`;

const SectionHeader = styled.h3`
  margin: 1.5rem 0px;
  font-weight: bold;
`;

const Playpen = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  width: 100%;
  height: 22rem;
  margin: 1.5rem 0px;
`;

const LunarBaby = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

const HeaderPlaypen = styled(Playpen)`
  height: 30rem;
`;

const HOME_URL = "camilodoa.github.io";

const Home = () => {
  return (
    <Container>
      <HeaderPlaypen>
        <LunarBaby title='Lunar baby' src={'https://'+ HOME_URL +'/lunarbaby'} name='Lunar baby' />
      </HeaderPlaypen>
        <Row>
          <Col md={'8'}>
            <Paragraph>
              Hi, I'm <b>Camilo</b>.
            </Paragraph>
            <Paragraph>
              I'm interested in web and reinforcement learning.
            </Paragraph>
            <Paragraph>
              At Google, I work on the Payments Platform's frontend experiences.
              My scope extends from card management on the <Link src="https://myaccount.google.com/payments-and-subscriptions">Payments & Subscriptions</Link> page 
              on Google Account to much of what appears in the <Link src="https://payments.google.com">Google Payments Center</Link>.
            </Paragraph>
          </Col>
        </Row>
        <Row>
          <Col md={'8'}>
            <SectionHeader>
              Selected projects
            </SectionHeader>
          </Col>
        </Row>
        <Project
          media={<Image alt='AI Melts ICE' src={'../img/ai-melts-ice.png'} fluid />}
          name='AI Melts ICE'
          link={'https://'+ HOME_URL +'/ai-melts-ice'}
          description={
            'was a web app designed to visualize\n' +
            '          historical and predicted data of county-specific ICE arrests in the US. The predictions were\n' +
            '          generated by an LSTM neural network trained on longitudinal data (2014 - 2018)\n' +
            "          from Syracuse's TRAC web API."
          }
        />
        <Project
          media={
            <Playpen>
              <LunarBaby title='Deep reinforcement learning agent' src={'https://'+ HOME_URL +'/dra'} name='Dra' />
            </Playpen>
          }
          name='Dra'
          link={'https://'+ HOME_URL +'/dra'}
          description={
            'explores the Sisyphean condition of a web-based\n' +
            'creature. Here lives a Deep Q-Network agent that learns to approach the goal\n' +
            'at the center of the page. Whenever it reaches the goal, it teleports somewhere else.'
          }
        />
    </Container>
  );
};

export default Home;
